export function parseAwinAdvertiserId(value: string | undefined): string | null {
  return value !== undefined && /^\d+$/.test(value) ? value : null;
}
